export const T = {
  en_GB: {
    ok: "Data feed OK",
    syncDisabled: "Data sync disabled",
    syncFailing: "Data sync failing",
    stale: "Data is stale",
    lastError: "Last error",
    lastUpdate: "Last data point",
    failures: "failed attempts",
  },
  nb_NO: {
    ok: "Datakilde OK",
    syncDisabled: "Datasynkronisering deaktivert",
    syncFailing: "Datasynkronisering feiler",
    stale: "Data er utdatert",
    lastError: "Siste feil",
    lastUpdate: "Siste datapunkt",
    failures: "mislykkede forsøk",
  },
} as const;

/**
 * The same states, worded for a derived series (a combined instrument, QL-333):
 * nothing is synced from a provider, the series is recomputed from its legs.
 */
export const T_RECOMPUTE = {
  en_GB: {
    ok: "Last recompute succeeded",
    syncDisabled: "Recompute disabled",
    syncFailing: "Recompute failing",
    stale: "No successful recompute lately",
    lastError: "Reason",
    lastUpdate: "Last recompute",
    failures: "failed attempts",
  },
  nb_NO: {
    ok: "Siste beregning lyktes",
    syncDisabled: "Beregning deaktivert",
    syncFailing: "Beregningen feiler",
    stale: "Ingen vellykket beregning i det siste",
    lastError: "Årsak",
    lastUpdate: "Siste beregning",
    failures: "mislykkede forsøk",
  },
} as const;
